import React from 'react';
import styled from '@emotion/styled';
import { Colors, FCC, Fonts } from '@zazume/zzm-base';

const Container = styled.div<any>`
  font-family: ${Fonts.BASE};
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0;
  color: ${Colors.FONT_2};
`;

/**
 * @deprecated use zzm-base
 * @param props
 * @constructor
 */
export const Footnote: FCC<any> = (props) => {
  return <Container {...props}>{props.children}</Container>;
};
